module.exports = __webpack_public_path__ + "static/IAMAI-India-Digital-Awards-2020-b5d5eff540a80884882a057259880621.png";